import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const mentalHealthEvaluationsMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.MENTAL_HEALTH_EVALUATIONS,
  iFrameSrcUrl: '/mental-health-evaluations',
  micrositeUrl: 'mental-health-evaluations',
  title: {
    id: 'mentalHealthEvaluations.title',
    defaultMessage: 'Mental health evaluations',
    description: 'Microsite page title for mental health evaluations',
  },
  featureFlag: 'isMHEMicrositeFeatureEnabled',
  customerPropertyConditions: [],
  postMessageEvents: [{ key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_DIRECT_PATH_BOOKING }],
  // TODO(CEA-3914): Replace these placeholder analytics values with the approved metadata.
  page: 'mental health evaluations',
  trackUTMParams: {
    utm_campaign: 'mental-health-evaluations',
  },
  shouldSupportSpanish: false,
  shouldHideForInternational: true,
  usePageForViewEvent: true,
}
